import { profileTypes } from '../types/profile'
import profileService from 'src/services/profile'
import { action } from 'typesafe-actions'
import { getErrorHelper } from 'src/utils/response-helpers'
import useUserData from 'src/hooks/useUserData'

export const verifyBankSettingsLoading = (loading: boolean) => {
  return {
    type: profileTypes.VERIFY_BANK_SETTINGS_LOADING,
    payload: loading,
  }
}

export const verifyBankSettingsSuccess = (data: any) => {
  return {
    type: profileTypes.VERIFY_BANK_SETTINGS_SUCCESS,
    payload: data,
  }
}

export const verifyBankSettingsFailure = (error: any) => {
  return {
    type: profileTypes.VERIFY_BANK_SETTINGS_FAILURE,
    payload: error,
  }
}

export const changePasswordAction = ({ payload, onSuccess, onError }: any) => {
  const { PasswordSettings } = payload
  return async (dispatch: any) => {
    dispatch(action(profileTypes.UPDATE_PASSWORD_LOADING))
    try {
      const response: any = await profileService.updatePassword(
        PasswordSettings
      )
      if (!response.data.data.successful) {
        onError?.(response.data.data.server_response)
      } else {
        dispatch(
          action(profileTypes.UPDATE_PASSWORD_SUCCESS, response.data.data)
        )
        onSuccess?.(response.data.data.server_response)
      }
    } catch (error) {
      getErrorHelper(error)
    }
  }
}
export const resetPinAction = ({ payload, onSuccess, onError }: any) => {
  const { PinSettings } = payload
  return async (dispatch: any) => {
    dispatch(action(profileTypes.UPDATE_PIN_LOADING))
    try {
      const response: any = await profileService.resetPin(PinSettings)
      if (!response.data.data.successful) {
        onError?.(response.data.data.server_response)
      } else {
        dispatch(action(profileTypes.UPDATE_PIN_SUCCESS, response.data.data))
        onSuccess?.(response.data.data.server_response)
      }
    } catch (error) {
      getErrorHelper(error)
    }
  }
}

export const updateProfileAction = ({ payload, onSuccess, onError }: any) => {
  const { profileSettings } = payload
  return async (dispatch: any) => {
    const USER_DATA: any = useUserData()
    dispatch(action(profileTypes.UPDATE_PROFILE_LOADING))
    try {
      const response: any = await profileService.updateProfile(profileSettings)
      if (!response.data.data.successful) {
        onError(getErrorHelper(response.data.message))
      } else {
        onSuccess?.(response.data.data.server_response)
        USER_DATA.user.first_name = profileSettings.first_name
        USER_DATA.user.last_name = profileSettings.last_name
        USER_DATA.user.phone_number = profileSettings.phone_number
        USER_DATA.user.email = profileSettings.email
        localStorage.setItem('USER_DATA', JSON.stringify(USER_DATA))
        dispatch(
          action(profileTypes.UPDATE_PROFILE_SUCCESS, response.data.data)
        )
      }
    } catch (error) {
      getErrorHelper(error)
    }
  }
}

export const updateAvatarAction = ({ payload, onSuccess, onError }: any) => {
  const avatar = payload
  return async (dispatch: any) => {
    dispatch(action(profileTypes.UPDATE_AVATAR_LOADING))
    try {
      const response: any = await profileService.updateAvatar(avatar)
      if (!response.data.data.successful) {
        onError(getErrorHelper(response.data.message))
      } else {
        onSuccess?.(response.data.data.server_response)
      }
      dispatch(action(profileTypes.UPDATE_AVATAR_SUCCESS, response.data.data))
      const USER_DATA: any = useUserData()
      USER_DATA.user.profile_picture = avatar.avatar
      localStorage.setItem('USER_DATA', JSON.stringify(USER_DATA))
    } catch (error) {
      getErrorHelper(error)
    }
  }
}

export const updateNextOfKinAction = ({ payload, onSuccess, onError }: any) => {
  const { NextOfKinSettings } = payload
  return async (dispatch: any) => {
    dispatch(action(profileTypes.UPDATE_NEXT_OF_KIN_LOADING))
    try {
      const response: any = await profileService.updateNextOfKin(
        NextOfKinSettings
      )
      if (!response.data.data.successful) {
        onError(getErrorHelper(response.data.message))
        dispatch(
          action(profileTypes.UPDATE_NEXT_OF_KIN_FAILURE, response.data.message)
        )
      } else {
        onSuccess?.(response.data.data.server_response)
        // Promise.all([getNextOfKinAction()])
      }
      dispatch(
        action(profileTypes.UPDATE_NEXT_OF_KIN_SUCCESS, response.data.data)
      )
      dispatch(
        action(profileTypes.GET_NEXT_OF_KIN_SUCCESS, response.data.data.data)
      )
    } catch (error) {
      onError(getErrorHelper(error))
    }
  }
}

export const getNextOfKinAction = () => {
  return async (dispatch: any) => {
    try {
      const response: any = await profileService.getNextOfKin()
      dispatch(action(profileTypes.GET_NEXT_OF_KIN_SUCCESS, response.data.data))
    } catch (error: any) {
      console.log(error.message)
    }
  }
}

export const createPinAction = ({ userData, onSuccess, onError }: any) => {
  return async (dispatch: any) => {
    try {
      const USER_DATA: any = useUserData()
      const response: any = await profileService.createPin(userData)
      if (!response.data.data.successful) {
        onError(getErrorHelper(response.data.message))
      } else {
        onSuccess?.(response.data.data.server_response)
        USER_DATA.user.has_withdrawal_pin = true
        localStorage.setItem('USER_DATA', JSON.stringify(USER_DATA))
      }
      dispatch(action(profileTypes.CREATE_PIN_SUCCESS, response.data.data))
    } catch (error) {
      getErrorHelper(error)
    }
  }
}
